import { publications } from "../data/content";

export default function Publications() {
  const byYear = [...publications].sort((a, b) => b.year - a.year);

  return (
    <div className="page pubs-page">
      <header className="page-header">
        <h1>Publications</h1>
        <p>Sample papers and preprints — swap in your real citations later.</p>
      </header>

      <ol className="pub-list">
        {byYear.map((pub) => (
          <li key={pub.title} className="pub-item">
            <span className="pub-year">{pub.year}</span>
            <div className="pub-body">
              <h2>{pub.title}</h2>
              <p className="pub-authors">{pub.authors}</p>
              <p className="pub-venue">{pub.venue}</p>
              <div className="pub-links">
                {Object.entries(pub.links).map(([key, href]) => (
                  <a key={key} href={href}>
                    {key.toUpperCase()}
                  </a>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
